var _defs, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#linear-gradient);}.cls-2{fill:url(#linear-gradient-2);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 412.96,
    y1: 890.24,
    x2: 534.9,
    y2: 197.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a94095"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#a74598"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#a1539f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#966bab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#888cbd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#76b6d3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#6cccde"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6cccde"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 448.68,
    y1: 896.53,
    x2: 570.62,
    y2: 203.38,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a94095"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#a74598"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#a1539f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#966bab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#888cbd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#76b6d3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#6cccde"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6cccde"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M500,164a156,156,0,0,1,62.11,12.42,159.09,159.09,0,0,1,84.72,84.72,156,156,0,0,1,12.42,62.11V482.45H609.56V323.2a105.62,105.62,0,0,0-8.6-42.68,111.64,111.64,0,0,0-58.28-58.28,105.62,105.62,0,0,0-42.68-8.6h-8.28a110.64,110.64,0,0,0-40.13,11.14,112.76,112.76,0,0,0-32.17,23.89,107.24,107.24,0,0,0-21.34,33.76,108.9,108.9,0,0,0-7.64,40.77V482.45H340.75V323.2a156,156,0,0,1,12.42-62.11,159.09,159.09,0,0,1,84.72-84.72A156,156,0,0,1,500,164Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M659.25,519.47V678.71a156.67,156.67,0,0,1-13.38,61.15,164.46,164.46,0,0,1-34.08,50,158.82,158.82,0,0,1-50.32,33.76,158.33,158.33,0,0,1-122.94,0,158.6,158.6,0,0,1-50.32-33.76,164.11,164.11,0,0,1-34.08-50,156.31,156.31,0,0,1-13.38-61.15V519.47h49.69V678.71a105.58,105.58,0,0,0,8.6,42.68,111.71,111.71,0,0,0,58.28,58.29,105.75,105.75,0,0,0,42.68,8.6h8.28a110.76,110.76,0,0,0,40.13-11.15,112.3,112.3,0,0,0,32.17-23.89,107.3,107.3,0,0,0,21.34-33.76,108.83,108.83,0,0,0,7.64-40.77V519.47Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLogo);
export default __webpack_public_path__ + "static/media/iconLogo.72a4b782161638b7376a8d70bc28ecf0.svg";
export { ForwardRef as ReactComponent };